import './TryAgainButton.css';

const TryAgainButton = ({ onClick }) => {
  return <div className="button" onClick={onClick}>
    Try Again
  </div>
};

export default TryAgainButton;
